import React from "react";
import { useMsal } from "@azure/msal-react";
import { MenuItem } from "@mui/material";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

export const SignOutButton = (props) => {
  const { instance } = useMsal();
  const { onClick: onCloseMenu, ...rest } = props;

  const handleLogout = (e) => {
    // Close the surrounding Menu first so MSAL can take over the focus / popup
    // ownership cleanly. Then issue an absolute redirect logout (popup variant
    // requires both URIs to be fully-qualified or it silently no-ops).
    if (onCloseMenu) onCloseMenu(e);
    const origin = window.location.origin;
    instance.logoutRedirect({
      postLogoutRedirectUri: origin + "/",
    }).catch((err) => {
      console.error("logoutRedirect failed", err);
    });
  };

  return (
    <MenuItem
      onClick={handleLogout}
      sx={{
        color: "error.main",
        fontWeight: 600,
        borderRadius: 1,
      }}
      {...rest}
    >
      <LogoutOutlinedIcon fontSize="small" sx={{ mr: 1.5 }} />
      Sign out
    </MenuItem>
  );
};
